import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import {
  BodyText,
  Button,
  Card,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import SpotUnavailableLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg';

import { JOURNEY_MODE, useMode } from '@store/journey';
import { getBaseUrl } from '@utils/routing';

import './styles.scss';

interface ErrorIndicatorProps {
  message?: string;
}

const ErrorIndicator = ({ message }: ErrorIndicatorProps) => {
  const mode = useMode();
  const isInLifeMode = mode === JOURNEY_MODE.INLIFE;

  const handleBack = () => {
    if (isInLifeMode) {
      clearInLifeOrderAndRedirectToMyAccount();
      return;
    }
    location.href = `${getBaseUrl()}/bundle`;
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100%"
      direction="column"
      className="wrapper"
    >
      <Flex
        direction="column"
        spacing="2xl"
        width="100%"
        className="error__Container"
      >
        <Card
          spacing="2xl"
          direction="row"
          alignItems="center"
          variant="subtle"
          className="error__Card"
        >
          <img
            src={SpotUnavailableLight}
            alt=""
            className="error__Illustration"
          />
          <Flex direction="column" spacing="md">
            <Heading size="lg">Something went wrong</Heading>
            <BodyText>
              {message ||
                'An error has occurred while processing your information.'}
            </BodyText>
          </Flex>
        </Card>
        <Flex justifyContent="start" spacing="lg">
          <Button
            variant="outline"
            colorScheme="functional"
            type="button"
            onClick={handleBack}
          >
            {isInLifeMode ? 'Back to home' : 'Back to bundle'}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export { ErrorIndicator };
